import {jQuery as $, lodash as _} from 'lib/shim';



const SELECTOR = '.atom-checkbox';



class AtomCheckbox {

	constructor(app, $element){
		if( !$.isSet($element.dataDuo('primed')) ){
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = $.randomUuid(true);
			this._$element = $element;

			this._prime();
		}

		return $element;
	}



	_prime(){
		this._$element.makeStylable('stylable-checkbox atom-inputlabel');

		if( this._$element.hasClass('atom-checkbox') ){
			this._$element
				.removeClass('atom-checkbox')
				.parent('.stylable-checkbox')
				.addClass('atom-checkbox')
				.end()
			;
		}

		if( this._$element.hasClass('error') ){
			this._$element
				.removeClass('error')
				.parent('.stylable-checkbox')
				.addClass('error')
				.end()
			;
		}

		if( this._$element.is(':disabled') ){
			this._$element
				.parent('.stylable-checkbox')
				.addClass('disabled')
				.end()
			;
		}
	}
}



export function init(app){
	let $elements = $();

	$(SELECTOR).each(function(){
		let $this = $(this);

		$elements = $elements.add(new AtomCheckbox(app, $this));
	});

	return $elements;
}
